<template>
  <article class="spire-card" :class="cardClass">
    <header v-if="$slots.header" class="spire-card__header">
      <slot name="header" />
    </header>
    <section v-if="$slots.body" class="card__body">
      <slot name="body" />
    </section>
    <footer v-if="$slots.footer" class="spire-card__footer mt-auto pt-05">
      <slot name="footer" />
    </footer>
  </article>
</template>
<script setup>
defineProps({
  cardClass: { type: String, default: "" },
});
</script>
